import React, { useState } from "react";
import "../components/about.css"; // ✅ make sure this path is correct


function About() {
  const [searchQuery, setSearchQuery] = useState("");

  const handleSearch = (event) => {
    event.preventDefault();
    console.log("Searching for:", searchQuery);
  };

  return (
    <div className="about-container">
      <div className="about-card">
        <h1>Screen To Scene</h1>
        <p>
          Welcome! This project is a free tool for those who need an easy way to "herd the cattle", and by that we mean your friends, family, or just folks you'd like to connect with. It's a great way to not only organize outings, but it allows allows you to manage them without having to contact everyone directly. 
        </p>
        <p>
          One of the best features of this platform is the ability to make your events public. You can extend your social conduit to the general public with opportunity to make new friends who might be into the same weird stuff as you! Life is too short, live a little! 
        </p>
        <p>
         What're you waiting for? Sign up and start planning your outing. I mean, it's free, what have you got to lose? 
        </p>
      </div>
    </div>  

  );
} // ← this closing brace ends the function

export default About; // ← ✅ now it's outside
